import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';

import { LoadingSpinner } from '../../components/LoadingSpinner';

// Lazy-loaded as a unit: the documentation is a public side entrance, and nobody signing in to use
// the product should download it.
const DocsLayout = lazy(() =>
  import('./components/DocsLayout').then((m) => ({ default: m.DocsLayout })),
);
const IntroductionPage = lazy(() =>
  import('./pages/IntroductionPage').then((m) => ({ default: m.IntroductionPage })),
);
const QuickstartPage = lazy(() =>
  import('./pages/QuickstartPage').then((m) => ({ default: m.QuickstartPage })),
);
const AuthenticationPage = lazy(() =>
  import('./pages/AuthenticationPage').then((m) => ({ default: m.AuthenticationPage })),
);
const ErrorsPage = lazy(() => import('./pages/ErrorsPage').then((m) => ({ default: m.ErrorsPage })));
const EndpointPage = lazy(() =>
  import('./pages/EndpointPage').then((m) => ({ default: m.EndpointPage })),
);

function suspended(node: JSX.Element): JSX.Element {
  return (
    <Suspense
      fallback={
        <div className="flex justify-center py-12">
          <LoadingSpinner />
        </div>
      }
    >
      {node}
    </Suspense>
  );
}

/**
 * Public API documentation. Mounted at the top level, outside the authenticated `RouteGuard`, so an
 * integrator can read it without an account — the same reason `/login` sits out there.
 */
export const docsRoutes: RouteObject[] = [
  {
    path: '/docs',
    element: suspended(<DocsLayout />),
    children: [
      { index: true, element: suspended(<IntroductionPage />) },
      { path: 'quickstart', element: suspended(<QuickstartPage />) },
      { path: 'authentication', element: suspended(<AuthenticationPage />) },
      { path: 'errors', element: suspended(<ErrorsPage />) },
      { path: 'api/:group/:endpoint', element: suspended(<EndpointPage />) },
    ],
  },
];
